import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  TableHead,
  TableRow,
  TableCell,
  withStyles,
} from '@material-ui/core';

import { CommonFonts } from '@/theme';

const TableHeader = () => {
  const { t } = useTranslation();

  const headCells = [
    {
      id: 'customer_first_name',
      label: t('customers.customer_first_name'),
      width: '25%',
    },
    {
      id: 'customer_last_name',
      label: t('customers.customer_last_name'),
      width: '20%',
    },
    {
      id: 'customer_email',
      label: t('customers.customer_email'),
      width: '20%',
    },
    {
      id: 'customer_mobile',
      label: t('customers.customer_mobile'),
      width: '20%',
    },
    {
      id: 'customer_segment',
      label: t('customers.customer_segment'),
      width: '20%',
    },
    {
      id: 'empty',
      label: '',
      width: '15%',
    },
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            style={{
              width: headCell.width,
              borderBottom: 'none',
            }}
          >
            {headCell.label}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const StyledTableCell = withStyles(() => ({
  root: {
    borderBottom: 'none',
    ...CommonFonts.darkFont14,
    fontWeight: 'normal',
  },
  head: {
    backgroundColor: '#F3F5F7',
  },
  body: {
    ...CommonFonts.darkFont14,
  },
}))(TableCell);

export default TableHeader;
